var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("label", { staticClass: "hint-wrapper" }, [
    _vm._v(_vm._s(_vm.getLabel) + " "),
    _vm.hint
      ? _c("img", {
          attrs: {
            src: require(`@/common/assets/icons/help-${
              _vm.$route.path.startsWith("/gop/") ? "black" : "white"
            }-text.svg`),
            title: _vm.hint,
            alt: "hint"
          }
        })
      : _vm._e(),
    _vm.hint && _vm.displayHint
      ? _c("span", [_vm._v(_vm._s(_vm.hint))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }